// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import Container from '../../common/container/Container'
import DateBar from '../../common/date/DateBar'
import type { WithDateProps } from '../../common/date/withDate'
import withDate from '../../common/date/withDate'
import Loader from '../../common/loader/Loader'
import RestrictedView from '../auth/RestrictedView'
import Header from '../header/Header'
import type { Station } from '../station/stationTypes'
import withActiveStation from '../station/withActiveStation'
import Campaigns from './OldCampaigns'
import { Columns, DateSelectorWrapper, Main } from './OldDashboardComponents'
import { fetchFrontPage } from './oldDashboardQueries'
import DaySales from './OldDaySales'
import FeelingsMeter from './OldFeelingsMeter'
import FrontpageAlert from './OldFrontPageAlert'
import IncentiveSales from './OldIncentiveSales'
import Reservations from './OldReservations'

type Props = WithDateProps & {
  activeStation: Station
}

@withDate()
@withActiveStation
class OldDashboard extends React.Component<Props, { alertOpen: boolean }> {
  constructor(props: Props) {
    super(props)
    this.state = {
      alertOpen: true,
    }
  }
  formatDailySalesUpdatedTime(actualLastUpdatedAt: string) {
    const updatedTime = new Date(actualLastUpdatedAt)
    let hour = updatedTime.getHours()
    let min = updatedTime.getMinutes()
    hour = hour >= 10 ? hour : `0${hour}`
    min = min >= 10 ? min : `0${min}`
    return `${hour}:${min}`
  }

  closeAlert = () => {
    this.setState({ ...this.state, alertOpen: false })
  }

  componentDidMount() {
    this.setState({ ...this.state, alertOpen: true })
  }

  render() {
    const {
      activeStation: { id: stationId },
      onDateChange,
      date,
    } = this.props
    const startOfWeek = moment(date).startOf('isoWeek').format('YYYY-MM-DD')
    const endOfWeek = moment(date).endOf('isoWeek').format('YYYY-MM-DD')
    const startOfMonth = moment(date).startOf('month').format('YYYY-MM-DD')
    const endOfMonth = moment(date).endOf('month').format('YYYY-MM-DD')
    const variables = {
      stationId,
      date,
      fromDate: startOfWeek,
      toDate: endOfWeek,
      startOfMonth,
      endOfMonth,
    }

    return (
      <Main>
        <Header title='Etusivu' />
        <Query query={fetchFrontPage} variables={variables}>
          {({ loading, error, data }) => {
            const {
              oldDashboard: dashboard,
              reservations,
              weeklyIncentiveSales,
              monthlyIncentiveSales,
              campaigns = [],
              restaurantMenu,
              restaurantMenuPeriods = [],
            } = data || {}
            const { dailySales = {}, salesIncentive = {}, averageFeelingMeter = 0, feelingsCount = 0 } = dashboard || {}
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <RestrictedView requiredPermission='view_dashboard'>
                  <Container>
                    <Typography variant='h6'>Etusivu</Typography>
                    <FrontpageAlert
                      date={date}
                      restaurantMenu={restaurantMenu}
                      restaurantMenuPeriods={restaurantMenuPeriods}
                      alertOpen={this.state.alertOpen}
                      closeAlert={this.closeAlert}
                    />
                    <DateSelectorWrapper>
                      <DateBar date={date} onDateChange={onDateChange} />
                    </DateSelectorWrapper>
                    <Columns>
                      <IncentiveSales
                        actual={salesIncentive.actual}
                        target={salesIncentive.target}
                        date={date}
                        weeklyIncentiveSales={weeklyIncentiveSales}
                        monthlyIncentiveSales={monthlyIncentiveSales}
                      />
                      <DaySales
                        actual={dailySales.actual}
                        target={dailySales.target}
                        date={date}
                        lastUpdatedAt={
                          dailySales.actualLastUpdatedAt &&
                          this.formatDailySalesUpdatedTime(dailySales.actualLastUpdatedAt)
                        }
                      />
                      <FeelingsMeter feeling={averageFeelingMeter} count={feelingsCount} date={date} />
                    </Columns>
                    <Reservations rows={reservations} stationId={stationId} date={date} />
                    <Campaigns campaigns={campaigns} stationId={stationId} />
                  </Container>
                </RestrictedView>
              </Loader>
            )
          }}
        </Query>
      </Main>
    )
  }
}

export default OldDashboard
